module.exports = __webpack_public_path__ + "img/image 8.4823e94f.png";